import { EVENT_METHOD } from '@components/SingleSignOn/RegisterLogin/utils';

export const generateRegisterLoginError = (errorMessage, type = EVENT_METHOD.email) => ({
  type: type,
  errorMessage: errorMessage
});
